import { StatusCardIconResolver } from "./StatusCardIconResolver";
export default StatusCardIconResolver;
